<template>
  <div>
    <div>
      <h2 class="font-bold text-xl mb-6">SMS</h2>
      <div class="  mb-4 ">
        <base-input label="Template List">
          <select class="form-control">
            <option disabled="true">Select</option>
            <option>Happy Holi Template</option>
            <option>Republic Day Template</option>
          </select>
        </base-input>
      </div>
      <div class=" mb-4 ">
        <base-input
          label="Variable 1"
          placeholder="Enter..."
          v-model="variable1"
        />
      </div>
      <div class=" mb-4 ">
        <base-input
          label="Variable 2"
          placeholder="Enter..."
          v-model="variable3"
        />
      </div>
      <div class=" mb-4 ">
        <base-input
          label="Variable 3"
          placeholder="Enter..."
          v-model="variable3"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      variable1: "",
      variable2: "",
      variable3: ""
    };
  }
};
</script>
